import { useContext } from '@nuxtjs/composition-api'

export default function useRuntimeConfig() {
  return useContext().$config
}
